import { i18n } from './../../../i18n';
import { AudienceGroupKey } from './types';

const groupKeysName = () => ({
  [AudienceGroupKey.all]: i18n.t('adgroup_audicence_dmp_all'),
  [AudienceGroupKey.custom]: i18n.t('adgroup_audicence_dmp_custom'),
  [AudienceGroupKey.lookalike]: i18n.t('adgroup_audicence_dmp_lookalike'),
});

export const createOptionsGroupBySource = (
  allOptions,
  filterKeys = [AudienceGroupKey.all, AudienceGroupKey.custom, AudienceGroupKey.lookalike]
) => {
  const optionsGroupBySource = allOptions.reduce(
    (result, item) => {
      const key = item.source;

      if (!result[key]) {
        result[key] = [];
      }

      result[key].push(item);

      return result;
    },
    {
      '-1': allOptions,
    }
  );

  return Object.keys(groupKeysName())
    .filter(key => filterKeys.includes(key as AudienceGroupKey))
    .sort()
    .map(key => ({
      title: groupKeysName()[key],
      data: optionsGroupBySource[key] || [],
    }));
};
